import { supabase } from '../lib/supabaseClient';

export async function saveZipImportRecord(record) {
    if (!supabase) throw new Error('Supabase yapılandırılmamış.');

    const { data: { user } } = await supabase.auth.getUser();

    const { data, error } = await supabase
        .from('zip_imports')
        .insert({
            file_name: record.fileName,
            file_size: record.fileSize,
            properties_found: record.propertiesFound,
            properties_added: record.propertiesAdded,
            images_found: record.imagesFound,
            compression_stats: record.compressionStats || {},
            status: record.status || 'completed',
            error_message: record.errorMessage || null,
            property_ids: record.propertyIds || [],
            created_by: user?.id || null
        })
        .select()
        .single();

    if (error) throw error;
    return data;
}

export async function fetchZipImports() {
    if (!supabase) return [];

    const { data, error } = await supabase
        .from('zip_imports')
        .select('*')
        .order('import_date', { ascending: false });

    if (error) throw error;
    return data || [];
}
